




import { Component, Prop, Vue } from "vue-property-decorator";
import { ContractStatusCodes } from "@/models/contracts";

@Component({
  components: {
    "date-range-stat": () =>
      import("@/components/app/global/stats/_dateRangeStat.vue")
  }
})
export default class ContractClients extends Vue {
  @Prop({ default: "total" })
  public readonly contractStatus!: ContractStatusCodes;

  public get params() {
    const params = {};
    if (this.contractStatus) params["report"] = `["${this.contractStatus}"]`;
    return params;
  }

  public get trimmedStatus() {
    return this.contractStatus
      ? this.contractStatus.replace("contract_", "")
      : null;
  }

  public get attrs() {
    return this.$_.merge(
      {
        id: "contractClientsStats",
        label: this.$t("_.total_clients"),
        scope: "contract_clients",
        currencyCode: null,
        currencyBound: false,
        params: {
          type: "contract_clients",
          date_to: this.$moment().format("YYYY-MM-DD"),
          ...this.params
        },
        "value-path": `${this.trimmedStatus || "total"}.result[0].count`
      },
      this.$attrs
    );
  }
}
